import { Progress as MantineProgressBar } from '@mantine/core';
import type { ProgressProps as MantineProgressProps } from '@mantine/core';

import type { LockedProps } from '../types';

type ProgressProps = Omit<MantineProgressProps, LockedProps>;

export const Progress = (props: ProgressProps) => {
  const { size = 'xl', radius = 'xl' } = props;
  return <MantineProgressBar {...props} size={size} radius={radius} />;
};
